import checkStatus from '../../../../shared/http/checkStatus';
import HttpMethods from '../../../../shared/api/HttpMethods';
import apiSlice from '../../../../shared/api/apiSlice';

// Описываем методы обращения к беку
const companyAccountsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyInfo: builder.query({
      query: ({ id }) => ({
        url: `/companies/${id}`,
        method: HttpMethods.GET,
        validateStatus: checkStatus,
      }),
    }),
    getCompanyAccounts: builder.query({
      query: ({ params }) => ({
        url: `/company-accounts`,
        method: HttpMethods.GET,
        params,
        validateStatus: checkStatus,
      }),
      providesTags: ['companyAccounts'],
    }),
    putCompanyAccount: builder.mutation({
      query: ({ body, id }) => ({
        url: `company-accounts/${id}`,
        method: HttpMethods.PUT,
        body,
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['companyAccounts'],
    }),

    checkCompanyBalance: builder.query({
      query: ({ id }) => ({
        url: `/companies/${id}/check-balance`,
        method: HttpMethods.GET,
        validateStatus: checkStatus,
      }),
    }),
    getCompanies: builder.query({
      query: (params) => ({
        url: `/companies`,
        method: HttpMethods.GET,
        params,
        validateStatus: checkStatus,
      }),
    }),
  }),
});

export const { useGetCompaniesQuery } = companyAccountsApi;

export default companyAccountsApi;
